import { lazy } from 'react'

import { PostListOrderByEnum } from '@tribeplatform/gql-client/types'
import { FeedProps } from '@tribeplatform/react-components/Feed'
import { I18nShape } from '@tribeplatform/react-components/i18n'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { BlockType, RegisteredBlock } from '../../types/index.js'
import { FeedBlock as Component } from './Block.js'

const Settings = lazy(() =>
  import('./Settings.js').then(m => ({ default: m.FeedBlockSettings })),
)

export const RegisteredFeedBlock = (
  intl: I18nShape,
): RegisteredBlock<FeedProps> => {
  const { $t } = intl

  return {
    recommendedName: 'Feed',
    Component,
    config: {
      type: BlockType.Block,
      usable: true,

      displayName: $t({ id: 'Generics.Feed', defaultMessage: 'Feed' }),
      Settings,
      Icon: <SvgIcon name="posts" />,
      defaultProps: {
        view: 'card',
        orderBy: PostListOrderByEnum.publishedAt,
      },
    },
  }
}
